import React from "react";
import { motion } from "framer-motion";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import {
  FaFacebookF, 
  FaReact,
  FaGithub,
  FaTelegram, 
  FaLinkedinIn,
} from "react-icons/fa";
import { SiNextdotjs, SiShopify, SiWordpress } from "react-icons/si";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ["E-Commerce Full Stack Developer"],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20 relative z-10">
      <motion.div
        className="flex flex-col gap-5"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.h4
          className="text-lg font-normal"
          whileHover={{ x: 10, color: "#ff014f" }}
          transition={{ duration: 0.2 }}
        >
          WELCOME TO MY WORLD
        </motion.h4>
        <motion.h1
          className="text-6xl font-bold text-white"
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          Hi, I'm <span className="text-designColor capitalize">Brian Van Nostrand</span>
        </motion.h1>
        <motion.h2
          className="text-3xl font-bold text-white"
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <span>{text}</span>
          <Cursor
            cursorBlinking={false}
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </motion.h2>

        <motion.p
          className="text-base font-bodyFont leading-6 tracking-wide text-justify"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          Senior E-Commerce Full Stack Developer with 9+ years of experience building high-performance platforms across Shopify, Shopify Plus, WordPress, WooCommerce and BigCommerce.
          <br /> 
          Full-stack expert in React, Next.js, TypeScript, Node.js, and GraphQL APIs. Specialized in Shopify Plus customization, payment/logistics integrations, CRO, and SEO optimization. Delivered measurable results including improved Lighthouse scores, higher conversion rates, and faster load times.
          <br /> 
          Experienced in automation tools (Zapier, Klaviyo, GA4) and AI-assisted workflows. Comfortable leading projects end-to-end while collaborating with cross-functional teams. Seeking senior opportunities where technical leadership meets e-commerce growth.
        </motion.p>
      </motion.div>
      <motion.div
        className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.6 }}
      >
        <div className="px-5">
          <h2 className="text-base uppercase font-titleFont mb-4">
            Find me in
          </h2>
          <div className="flex gap-4">
            
            <motion.a
              href="https://www.linkedin.com/in/brian-nostrand-87b53738b/"
              target="blank"
              whileHover={{ y: -5, rotate: 5 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="bannerIcon">
                <FaLinkedinIn />
              </span>
            </motion.a>
            <motion.a
              href="https://www.facebook.com/bmars8218/"
              target="blank"
              whileHover={{ y: -5, rotate: -5 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="bannerIcon">
                <FaFacebookF />
              </span>
            </motion.a>
            
            <motion.a
              href="https://t.me/Bmars8218"
              target="blank"
              whileHover={{ y: -5, rotate: -5 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="bannerIcon">
                <FaTelegram />
              </span>
            </motion.a>
            <motion.a
              href="https://github.com/ErPing-CMS"
              target="blank"
              whileHover={{ y: -5, rotate: 5 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="bannerIcon">
                <FaGithub />
              </span>
            </motion.a>
          </div>
        </div>
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL ON
          </h2>
          <div className="flex gap-4">
            <motion.span
              className="bannerIcon"
              whileHover={{ y: -5, rotate: -360 }}
              transition={{ duration: 0.6 }}
            >
              <SiShopify />
            </motion.span>
            <motion.span
              className="bannerIcon"
              whileHover={{ y: -5, scale: 1.1 }}
              transition={{ duration: 0.3 }}
            >
              <SiWordpress />
            </motion.span>
            <motion.span
              className="bannerIcon"
              whileHover={{ y: -5, rotate: 360 }}
              transition={{ duration: 0.6 }}
            >
              <FaReact />
            </motion.span>
            <motion.span
              className="bannerIcon"
              whileHover={{ y: -5, scale: 1.1 }}
              transition={{ duration: 0.3 }}
            >
              <SiNextdotjs />
            </motion.span>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default LeftBanner;
